// extracted by mini-css-extract-plugin
export default {"wrapperBlock":"styles_wrapperBlock__cN0CX","errorMessage":"styles_errorMessage__afQ9O"};